import React from "react";
import { VeriAsyncSelectProps } from "./VeriAsyncSelect.types";
import { FieldPath, Controller } from "../../../../react-hook-form";
import { VeriCustomSelect } from "../VeriCustomSelect";
import { VeriCustomSelectOption } from "../VeriCustomSelect/VeriCustomSelect.types";

const VeriAsyncSelect = <T, K extends FieldPath<T>>({
  name,
  form,
  onChange: userOnChange,
  ...rest
}: VeriAsyncSelectProps<T, K>) => {
  return (
    <Controller
      rules={{
        required: rest.isRequired ? "This field is required" : undefined,
      }}
      control={form.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <VeriCustomSelect
          valueOption={
            value
              ? ({
                  ...value,
                  value:
                    (value as VeriCustomSelectOption)?.value ||
                    (value as { id: string })?.id ||
                    "",
                } as never)
              : null
          }
          onChange={(value, option) => {
            onChange(option);
            userOnChange?.(value, option);
          }}
          filterDelay={300}
          error={error?.message}
          {...rest}
        />
      )}
      name={name}
    />
  );
};

export default VeriAsyncSelect;
